import { Component, OnDestroy, OnInit } from '@angular/core'
import { FormBuilder, UntypedFormGroup } from '@angular/forms'
import { ContactInfo } from '@se-po/shared-data-access-models'
import { SeFeDocsExampleComponent } from 'se-fe-docs-example'
import { SeFeFormService } from 'se-fe-form-service'
import { SeFeToastService } from 'se-fe-toast'
import { Persona } from 'se-resource-types/dist/lib/UserService'

const exampleHtml = `
<div *ngIf="form">
  <form [formGroup]="form" (ngSubmit)="submit()" novalidate>
    <se-po-child-contact-info
      [persona]="persona"
      formControlName="childContactInfo">
    </se-po-child-contact-info>
    <div class="form-submit">
      <se-fe-button
        seFeDataEmphasis="high"
        seFeDataType="submit">
        Submit
      </se-fe-button>
    </div>
  </form>
  <div class="form-value">
    <code>
      {{ form.value | json }}
    </code>
  </div>
</div>
`

const exampleTypescript = `
import { Component, OnInit } from '@angular/core'
import { FormBuilder, UntypedFormGroup } from '@angular/forms'
import { ContactInfo } from '@se-po/shared-data-access-models'
import { SeFeFormService } from 'se-fe-form-service'
import { SeFeToastService } from 'se-fe-toast'
import { Persona } from 'se-resource-types/dist/lib/UserService'

export class ChildContactInfoExampleComponent implements OnInit {
  public form: UntypedFormGroup
  public persona: Persona

  constructor(
    private fb: FormBuilder,
    private formService: SeFeFormService,
    private seFeToastService: SeFeToastService
  ) { }

  public ngOnInit(): void {
    this.persona = {
      first_name: 'Greg',
      last_name: 'Neves',
      gender: 'male',
      date_of_birth: '2002-01-02'
    } as Persona
    const contactInfo: ContactInfo = {
      email: '',
      phone: ''
    } as ContactInfo
    this.form = this.fb.group({
      childContactInfo: [contactInfo]
    })
  }

  public submit(): void {
    const valid = this.formService.isValid(this.form)
    if (!valid) {
      console.log('validation failed')
      console.log(this.form)
    } else {
      this.seFeToastService.success('Submitted form')
    }
  }
}
`

const template = `<se-fe-docs-example [example]="this">${ exampleHtml }</se-fe-docs-example>`

@Component({
  selector: 'se-po-child-contact-info-example',
  template,
  styleUrls: ['./child-contact-info-docs.component.scss'],
  standalone: false,
})
export class ChildContactInfoExampleComponent extends SeFeDocsExampleComponent implements OnInit, OnDestroy {
  public files = [
    { src: exampleHtml, name: 'Template', lang: 'html' },
    { src: exampleTypescript, name: 'Typescript', lang: 'typescript' },
  ]
  public form: UntypedFormGroup
  public persona: Persona

  constructor(
    private fb: FormBuilder,
    private formService: SeFeFormService,
    private seFeToastService: SeFeToastService
  ) {
    super()
  }

  public ngOnInit(): void {
    this.persona = {
      first_name: 'Greg',
      last_name: 'Neves',
      gender: 'male',
      date_of_birth: '2002-01-02'
    } as Persona
    const contactInfo: ContactInfo = {
      email: '',
      phone: ''
    } as ContactInfo
    this.form = this.fb.group({
      childContactInfo: [contactInfo]
    })
  }

  public ngOnDestroy(): void {
    this.seFeToastService.events.next(undefined)
  }

  public submit(): void {
    const valid = this.formService.isValid(this.form)
    if (!valid) {
      console.log('validation failed')
      console.log(this.form)
    } else {
      this.seFeToastService.success('Submitted form')
    }
  }
}
